import { createTheme, MantineProvider } from '@mantine/core';
import { ReactNode } from 'react';

export default function ScaledMantineProvider({
  children,
  shadowContainer,
}: {
  children: ReactNode;
  shadowContainer: HTMLElement;
}) {
  /**
   * The only thing that can come through the shadow DOM from the outer scope is the html font-size. Unfortunately,
   * many sites set this. Mantine uses this font-size to calculate the scale factor for its rem units. To counteract
   * this, we calculate the scale factor based on the html font-size and pass it to Mantine. This also means that when
   * you are using rem, you need to multiply it by the scale factor (i.e. instead of using 0.875rem in a style, you need
   * to use calc(0.875rem * var(--mantine-scale))).
   */
  const htmlFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const scale = 16 / htmlFontSize; // Mantine docs: set scale = 1 / (htmlPx/16)
  const theme = createTheme({
    components: {
      // Center modals on the screen, not on the react app.
      Modal: {
        styles: {
          inner: {
            left: 0,

            right: 0,
            // Keep modals above the Seward Folly navigation dropdown.
            zIndex: 1201,
          },
        },
      },

      // Keep portals/popovers/modals inside the shadow DOM
      Portal: { defaultProps: { target: shadowContainer } },
    },
    scale,
  });

  return (
    <MantineProvider
      theme={theme}
      cssVariablesSelector={`#${shadowContainer.id}`}
      getRootElement={() => shadowContainer}
    >
      {children}
    </MantineProvider>
  );
}
